// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__kbfvX","selects":"Documents_selects__1hPsU"};